var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFigSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.34167 4C4.34167 1.79086 6.13254 0 8.34167 0H24.3417L36.3417 12V36C36.3417 38.2091 34.5508 40 32.3417 40H8.34167C6.13254 40 4.34167 38.2091 4.34167 36V4Z",
    fill: "#7F56D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M24.3417 0L36.3417 12H28.3417C26.1325 12 24.3417 10.2091 24.3417 8V0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2352 32H14.1014V25.6587H18.1444V26.6167H15.2352V28.4888H17.8939V29.4116H15.2352V32ZM20.1044 32H18.9706V25.6587H20.1044V32ZM26.7709 29.3545C26.7709 31.0728 25.7426 32.1055 24.0067 32.1055C22.1566 32.1055 21.0052 30.8486 21.0052 28.8052C21.0052 26.7925 22.1522 25.5532 23.9847 25.5532C25.4261 25.5532 26.516 26.4058 26.7225 27.6758H25.5712C25.3558 26.9463 24.767 26.5156 23.9891 26.5156C22.8466 26.5156 22.1654 27.3638 22.1654 28.792C22.1654 30.251 22.8773 31.1431 24.0199 31.1431C24.9779 31.1431 25.6415 30.5366 25.6591 29.6489L25.6635 29.5435H24.1342V28.6777H26.7709V29.3545Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigSvg);
export default __webpack_public_path__ + "static/media/figSvg.3c8540164abec744142fd2c1cfc6f0ca.svg";
export { ForwardRef as ReactComponent };